// Test IDs for the public real-time statistics shown on the landing page.
export const STATS = {
	panel: 'public-stats-panel',
	registered: 'public-stats-registered',
	views: 'public-stats-views',
	videos: 'public-stats-videos',
	online: 'public-stats-online',
};
